export function sessionExpired() {
    return {
        type: "SESSION_EXPIRED"
    }
}

export function signOut() {
    return {
        type: "SIGN_OUT"
    }
}


// WEBPACK FOOTER //
// ./src/actions/signOut.js